import React, { useState } from 'react';
import { Send } from 'lucide-react';
interface ChatWindowProps {
  title: string;
  placeholder?: string;
  initialMessage?: string;
  detailLevel?: number;
  icon?: React.ReactNode;
  onComplete?: () => void;
}
export const ChatWindow = ({
  title,
  placeholder,
  initialMessage,
  detailLevel = 1,
  icon,
  onComplete
}: ChatWindowProps) => {
  const [message, setMessage] = useState(initialMessage || '');
  const handleSubmit = () => {
    if (message.toLowerCase().trim() === 'next') {
      onComplete?.();
    }
  };
  return <div className="bg-white rounded-lg shadow-sm border border-gray-200 h-[300px] flex flex-col" data-id="element-101">
      <div className="p-3 border-b border-gray-200 flex items-center justify-between" data-id="element-102">
        <div className="flex items-center gap-2" data-id="element-103">
          {icon}
          <h3 className="font-medium text-gray-700" data-id="element-104">{title}</h3>
        </div>
        <div className="flex items-center gap-1" data-id="element-105">
          {[...Array(3)].map((_, i) => <div key={i} className={`w-1.5 h-1.5 rounded-full ${i < detailLevel ? 'bg-purple-500' : 'bg-gray-200'}`} data-id="element-106" />)}
        </div>
      </div>
      <div className="flex-1 p-4 overflow-auto" data-id="element-107">
        <p className="text-gray-600 mb-2" data-id="element-108">
          Type "next" when you're ready to continue
        </p>
      </div>
      <div className="p-3 border-t border-gray-200" data-id="element-109">
        <div className="flex gap-2" data-id="element-110">
          <textarea value={message} onChange={e => setMessage(e.target.value)} placeholder={placeholder} className="flex-1 resize-none border border-gray-300 rounded-md p-2 focus:ring-2 focus:ring-[#6366f1] focus:border-transparent outline-none" rows={3} data-id="element-111" />
          <button onClick={handleSubmit} className="self-end p-2 bg-[#d5ff00] text-gray-900 rounded-md hover:bg-[#c0e600]" data-id="element-112">
            <Send size={20} data-id="element-113" />
          </button>
        </div>
      </div>
    </div>;
};